var map = {
	"./BuddyBonus_en.png": 37725,
	"./BuddyBonus_zh.png": 29654,
	"./auth/2FA-icon.png": 12631,
	"./auth/2FA-not-working.png": 68193,
	"./auth/account-recovery.png": 85170,
	"./auth/corporate.png": 85493,
	"./auth/document-text.png": 73904,
	"./auth/email-icon.png": 75584,
	"./auth/email_activation.png": 93169,
	"./auth/error.png": 37330,
	"./auth/eye-slash.svg": 90561,
	"./auth/eye.svg": 42575,
	"./auth/global_coin.png": 87025,
	"./auth/global_coin_in.png": 38647,
	"./auth/google.svg": 13995,
	"./auth/individual.png": 25221,
	"./auth/lock-icon.png": 40840,
	"./auth/malaysia_coin.png": 61037,
	"./auth/malaysia_coin_in.png": 62721,
	"./auth/message.png": 42504,
	"./auth/no-update.png": 85336,
	"./auth/passkeys.png": 20770,
	"./auth/password-icon.png": 39609,
	"./auth/phone-icon.png": 60386,
	"./contents/aboutus/1_aboutus.png": 19599,
	"./contents/aboutus/1_aboutus.webp": 63257,
	"./contents/aboutus/3_darien-mascot.png": 11488,
	"./contents/aboutus/3_darien.png": 37669,
	"./contents/aboutus/3_david-low.png": 64481,
	"./contents/aboutus/3_david-mascot.png": 81429,
	"./contents/aboutus/3_kk-mascot.png": 64299,
	"./contents/aboutus/3_kk.png": 47349,
	"./contents/aboutus/3_linkedin.svg": 70535,
	"./contents/aboutus/4_customer-first.png": 22278,
	"./contents/aboutus/4_fuel-crypto.png": 55692,
	"./contents/aboutus/4_rocket-solution.png": 85856,
	"./contents/aboutus/5_accountability.png": 43157,
	"./contents/aboutus/5_collaboration.png": 18331,
	"./contents/aboutus/5_growth.png": 68670,
	"./contents/aboutus/5_progression.png": 72326,
	"./contents/aboutus/investor_alliance.png": 51192,
	"./contents/aboutus/investor_ap-capital.png": 65195,
	"./contents/aboutus/investor_bybit.png": 90119,
	"./contents/aboutus/investor_cadenza.png": 40815,
	"./contents/aboutus/investor_castle-island-ventures.png": 75299,
	"./contents/aboutus/investor_plug-and-play.png": 96717,
	"./contents/affiliate/1_affiliate.png": 24105,
	"./contents/affiliate/2_signup.png": 54457,
	"./contents/affiliate/3_share.png": 68007,
	"./contents/affiliate/4_get.png": 66953,
	"./contents/buddybonus/1_buddybonus.png": 84011,
	"./contents/buddybonus/2_signup.png": 65488,
	"./contents/buddybonus/3_share.png": 7631,
	"./contents/buddybonus/4_RMcoin.png": 95650,
	"./contents/custody/1_custody-factory.mp4": 49490,
	"./contents/custody/1_custody-factory.webp": 95336,
	"./contents/custody/1_labuan.png": 15879,
	"./contents/custody/1_securities-commission.png": 73286,
	"./contents/custody/2_assistance.png": 9097,
	"./contents/custody/2_encryption.png": 84371,
	"./contents/custody/2_licensed.png": 35004,
	"./contents/custody/2_personal-info.png": 90331,
	"./contents/custody/2_protection.png": 23300,
	"./contents/custody/2_secure.png": 83736,
	"./contents/custody/3_airgaps.png": 18888,
	"./contents/rewards/1_rewarded.png": 11235,
	"./contents/rewards/2_buddybonus.png": 31217,
	"./contents/rewards/3_affiliate.png": 63232,
	"./custom_icon/CustomLeftIcon": 48982,
	"./custom_icon/CustomLeftIcon.vue": 48982,
	"./custom_icon/CustomRightIcon": 93237,
	"./custom_icon/CustomRightIcon.vue": 93237,
	"./custom_icon/RewardIcon": 34983,
	"./custom_icon/RewardIcon.vue": 34983,
	"./header/dropdown-logout.png": 37522,
	"./header/dropdown-logout.svg": 17531,
	"./header/dropdown-profile.png": 33930,
	"./header/dropdown-profile.svg": 22186,
	"./header/dropdown-security.png": 68472,
	"./header/dropdown-security.svg": 62216,
	"./header/dropdown-settings.png": 17999,
	"./header/dropdown-settings.svg": 54481,
	"./header/footer/facebook.svg": 78705,
	"./header/footer/instagram.svg": 88804,
	"./header/footer/linkedin.svg": 73071,
	"./header/footer/telegram.svg": 77852,
	"./header/footer/tiktok.svg": 44718,
	"./header/footer/twitter.svg": 51859,
	"./header/footer/youtube.svg": 12100,
	"./header/hataLogo.png": 16155,
	"./header/loading_bar.gif": 50452,
	"./header/loading_lines.gif": 29898,
	"./header/profile-icon.svg": 15563,
	"./header/sidebar/bell.svg": 61924,
	"./header/sidebar/buy_crypto.svg": 28695,
	"./header/sidebar/career.svg": 3276,
	"./header/sidebar/exchange.svg": 77375,
	"./header/sidebar/explore.svg": 19590,
	"./header/sidebar/help_centre.svg": 44822,
	"./header/sidebar/identification.svg": 41708,
	"./header/sidebar/message-question.svg": 59852,
	"./header/sidebar/myr.svg": 66063,
	"./header/sidebar/otc.svg": 94586,
	"./header/sidebar/profile.svg": 41811,
	"./header/sidebar/security.svg": 63442,
	"./header/sidebar/settings.svg": 86505,
	"./header/sidebar/usd.svg": 62687,
	"./header/sidebar/wallet.svg": 91408,
	"./header/sidebarIcon.svg": 97125,
	"./home/1_landing-factory.mp4": 80481,
	"./home/1_landing-factory.webp": 10021,
	"./home/2_BFM.png": 56265,
	"./home/2_CoinMarketCap.png": 24680,
	"./home/2_CoinTelegraph.png": 5303,
	"./home/2_TIA.png": 85937,
	"./home/2_TheEdge.png": 74823,
	"./home/2_cryptonews.png": 60874,
	"./home/3_custody.png": 67713,
	"./home/3_market.png": 40713,
	"./home/3_otc.png": 64253,
	"./home/3_wallet.png": 29868,
	"./home/4_backend.png": 1161,
	"./home/4_licensedTrustee.png": 6372,
	"./home/4_supervisedLegal.png": 92886,
	"./home/6_airplane1.png": 80440,
	"./home/6_airplane2.png": 33768,
	"./home/6_mobile_affiliate.png": 85988,
	"./home/6_referral.webp": 64759,
	"./home/6_referral2.webp": 70120,
	"./home/6_web_affiliate.png": 55028,
	"./home/7_appstore_badge.png": 61287,
	"./home/7_googlestore_badge.png": 69904,
	"./home/7_mobileApp.webp": 1197,
	"./home/8_auth.png": 43019,
	"./home/8_corner-mascot.png": 12794,
	"./home/8_fund.png": 13956,
	"./home/8_lady.webp": 93518,
	"./home/8_ladyHalf.webp": 62650,
	"./home/8_stand-mascot.png": 12787,
	"./home/8_stand-mascot.webp": 37738,
	"./home/8_trade.png": 24158,
	"./home/BusinessOTC/1_landing-OTC.mp4": 25526,
	"./home/BusinessOTC/1_landing-OTC.png": 12526,
	"./home/BusinessOTC/1_landing-OTC.webp": 76531,
	"./home/BusinessOTC/2_liquidity.png": 7368,
	"./home/BusinessOTC/2_listing.png": 9203,
	"./home/BusinessOTC/2_quotes.png": 41236,
	"./home/BusinessOTC/3_best-price.png": 771,
	"./home/BusinessOTC/3_service.png": 61094,
	"./home/BusinessOTC/4_start-crypto.png": 22298,
	"./home/BusinessOTC/old otc.mp4": 92407,
	"./home/Global/banner-global.png": 70867,
	"./home/Global/banner-global1.png": 13303,
	"./home/Global/banner-global2.png": 83115,
	"./home/Global/banner-global3.png": 35948,
	"./home/Global/banner-global4.png": 16589,
	"./home/Global/banner-my.png": 24356,
	"./home/Global/banner-my0.png": 24212,
	"./home/Global/banner-my1.png": 30017,
	"./home/Global/banner-my2.png": 82258,
	"./home/Global/banner-my3.png": 8530,
	"./home/Global/banner-my4.png": 58567,
	"./home/Global/global-auto-invest.svg": 51980,
	"./home/Global/global-help.svg": 22582,
	"./home/Global/global-learn.svg": 34202,
	"./home/Global/global-reward.svg": 55842,
	"./home/Global/m-banner-global1.png": 71427,
	"./home/Global/m-banner-global2.png": 25501,
	"./home/Global/m-banner-global3.png": 98819,
	"./home/Global/m-banner-global4.png": 32585,
	"./home/Global/m-banner-my0.png": 13,
	"./home/Global/m-banner-my1.png": 45914,
	"./home/Global/m-banner-my2.png": 30218,
	"./home/Global/m-banner-my3.png": 40242,
	"./home/Global/m-banner-my4.png": 47124,
	"./home/Global/new-bubble.svg": 71415,
	"./home/Global/referral-rewards.svg": 9078,
	"./home/market_home.png": 7142,
	"./home/referral.svg": 67190,
	"./home/referral_mobile.svg": 61398,
	"./home/waitlist_img.webp": 20008,
	"./home/waitlist_success.webp": 53507,
	"./kyc/address-proof.png": 92843,
	"./kyc/blur-photo-id-back.png": 44487,
	"./kyc/blur-photo-id.png": 89672,
	"./kyc/blur-photo.png": 4034,
	"./kyc/calendar.svg": 17180,
	"./kyc/calendar_primary.svg": 88626,
	"./kyc/camera.png": 36837,
	"./kyc/camera.svg": 54086,
	"./kyc/clear-photo-id-back.png": 52073,
	"./kyc/clear-photo-id.png": 57250,
	"./kyc/clear-photo.png": 12484,
	"./kyc/cropped-photo-id-back.png": 80001,
	"./kyc/cropped-photo-id.png": 61655,
	"./kyc/cropped-photo.png": 51961,
	"./kyc/error-info.png": 80375,
	"./kyc/flip-camera.svg": 60693,
	"./kyc/house.png": 44767,
	"./kyc/house.svg": 63519,
	"./kyc/kyc-complete-icon.png": 2146,
	"./kyc/kyc-started.png": 76929,
	"./kyc/location.svg": 81560,
	"./kyc/personal-card-circle.png": 46539,
	"./kyc/personalcard-black.png": 72750,
	"./kyc/personalcard.png": 70816,
	"./kyc/personalcard.svg": 23159,
	"./kyc/profile-circle-black.png": 45227,
	"./kyc/profile-circle.png": 26822,
	"./kyc/profile-circle.svg": 48756,
	"./kyc/profile-info.png": 58375,
	"./kyc/proof-intro.png": 87671,
	"./kyc/proof-wealth-intro.png": 78337,
	"./kyc/proofOfAddress.png": 55741,
	"./kyc/receipt-text.png": 17340,
	"./kyc/receipt-text.svg": 50237,
	"./kyc/reside.png": 60820,
	"./kyc/screening.svg": 82502,
	"./kyc/security-lock.png": 47810,
	"./kyc/security-lock.svg": 22849,
	"./kyc/security-safe.png": 48265,
	"./kyc/selfie-frame.png": 3210,
	"./kyc/selfie-icon.png": 98602,
	"./kyc/selfie-intro.png": 48128,
	"./kyc/sheild-tick.png": 75080,
	"./kyc/shield-tick.svg": 16890,
	"./kyc/small-dropdown-icon.svg": 86453,
	"./kyc/statement-icon.png": 49259,
	"./kyc/tick-circle.png": 71087,
	"./kyc/tick-circle.svg": 67398,
	"./kyc/warning-blue-border.png": 78262,
	"./kyc/warning-blue.png": 19850,
	"./modal/2FA-icon-red.png": 9804,
	"./modal/Email.svg": 16722,
	"./modal/Line.svg": 3756,
	"./modal/Messenger.svg": 75141,
	"./modal/Telegram.svg": 38957,
	"./modal/Wechat.svg": 17521,
	"./modal/Whatsapp.svg": 12292,
	"./modal/address-icon.png": 93003,
	"./modal/buddybonus.png": 6671,
	"./modal/close-circle.png": 53690,
	"./modal/cookie_policy.png": 82379,
	"./modal/expired.png": 79289,
	"./modal/info-circle-dark.png": 16096,
	"./modal/info-circle.png": 98088,
	"./modal/info-circle.svg": 12141,
	"./modal/info.png": 9370,
	"./modal/invalid.png": 23156,
	"./modal/no-address.png": 29916,
	"./modal/pending-current.png": 65792,
	"./modal/pending-grey-icon.png": 39851,
	"./modal/pending.png": 84350,
	"./modal/pending2.png": 29025,
	"./modal/pending3.png": 38561,
	"./modal/platform-icon.png": 77170,
	"./modal/profile-info.png": 22270,
	"./modal/rejected-dark-icon.png": 32561,
	"./modal/rejected-icon.png": 32846,
	"./modal/rejected.png": 45825,
	"./modal/security.png": 18082,
	"./modal/share-icon.png": 31956,
	"./modal/success.png": 93847,
	"./modal/warning-dark.png": 51879,
	"./modal/warning.png": 14787,
	"./modal/white-close-circle.png": 529,
	"./modal/white-warning.png": 93413,
	"./notfound.png": 92333,
	"./payment/bitcoin-refresh.png": 97500,
	"./payment/bitcoin-refresh.svg": 24998,
	"./payment/payment.png": 89790,
	"./payment/profile-circle.png": 93387,
	"./payment/profile-circle.svg": 3533,
	"./payment/shield-tick.png": 20746,
	"./payment/shield-tick.svg": 67691,
	"./profile/1_referral.png": 55616,
	"./profile/2_referral-banner-mobile.png": 43088,
	"./profile/2_referral-banner.jpg": 61220,
	"./profile/affiliate.png": 1362,
	"./profile/announcement.png": 79302,
	"./profile/app-store.png": 68813,
	"./profile/approved.png": 49773,
	"./profile/attention.png": 3283,
	"./profile/blue-user.png": 86181,
	"./profile/change-email.png": 45078,
	"./profile/cloud.png": 62903,
	"./profile/curved-arrow-right.png": 80287,
	"./profile/edit.png": 49450,
	"./profile/enter-code-disable.svg": 86905,
	"./profile/enter-code.svg": 10731,
	"./profile/gradient-2fa.png": 10614,
	"./profile/gradient-ch_lang.png": 95089,
	"./profile/gradient-cloud.png": 76738,
	"./profile/gradient-communication.png": 79002,
	"./profile/gradient-download.png": 16546,
	"./profile/gradient-email.png": 42946,
	"./profile/gradient-en_lang.png": 84345,
	"./profile/gradient-global.png": 76828,
	"./profile/gradient-language.png": 53935,
	"./profile/gradient-malaysia.png": 43042,
	"./profile/gradient-news.png": 35436,
	"./profile/gradient-passkey.png": 59588,
	"./profile/gradient-password.png": 68352,
	"./profile/gradient-pending.png": 96122,
	"./profile/gradient-phone.png": 58212,
	"./profile/gradient-platform.png": 27198,
	"./profile/gradient-reward.png": 5662,
	"./profile/gradient-security.png": 3333,
	"./profile/gradient-setting.png": 19067,
	"./profile/gradient-share.png": 33326,
	"./profile/gradient-support24.png": 36969,
	"./profile/gradient-user.png": 9939,
	"./profile/gradient-user2.png": 69352,
	"./profile/gradient-verify.png": 30071,
	"./profile/gray-reward.png": 10176,
	"./profile/grey-invitees.png": 63258,
	"./profile/identification-approved.png": 56038,
	"./profile/identification-pending.png": 96841,
	"./profile/identification-rejected.png": 83338,
	"./profile/language.svg": 81368,
	"./profile/no-notification.png": 11559,
	"./profile/noti-delete.png": 88652,
	"./profile/noti-delete.svg": 35224,
	"./profile/noti-indivi-delete.svg": 22629,
	"./profile/noti-read.png": 74472,
	"./profile/noti-read.svg": 92457,
	"./profile/passkeys.png": 6024,
	"./profile/pending.png": 28749,
	"./profile/platform_success.png": 91266,
	"./profile/play-store.png": 75302,
	"./profile/referral-rewards.png": 89495,
	"./profile/rejected.png": 22282,
	"./profile/reward.png": 61462,
	"./profile/share-disable.svg": 49386,
	"./profile/share.svg": 35777,
	"./profile/singleRef_icon.png": 55744,
	"./profile/support24.svg": 39805,
	"./profile/warning.svg": 48183,
	"./trading/add-icon.svg": 24807,
	"./trading/auto-invest-blue.png": 86757,
	"./trading/auto-invest-grey.png": 61749,
	"./trading/filter-icon.svg": 4740,
	"./trading/no-data-dark.png": 79304,
	"./trading/no-data.png": 72086,
	"./trading/no-history-data.png": 77323,
	"./trading/orderbook_icon1.svg": 81098,
	"./trading/orderbook_icon2.svg": 27197,
	"./trading/orderbook_icon3.svg": 80027,
	"./trading/trading-view-dark.svg": 22154,
	"./trading/trading-view-light.svg": 58018,
	"./under_maintenance.png": 87176,
	"./wallet/add_new_address.png": 91901,
	"./wallet/address-book.svg": 220,
	"./wallet/arrow-down.svg": 26467,
	"./wallet/bank-icon.png": 92048,
	"./wallet/barcode-icon.svg": 68858,
	"./wallet/buy.svg": 6984,
	"./wallet/buyAction.svg": 99647,
	"./wallet/copy.svg": 29502,
	"./wallet/crossplatform-icon.svg": 32999,
	"./wallet/deposit.svg": 85864,
	"./wallet/depositAction.svg": 26124,
	"./wallet/deposit_success.png": 7479,
	"./wallet/document-copy.png": 79674,
	"./wallet/gradient-bank-icon.png": 90512,
	"./wallet/gradient-exchg-icon.png": 73594,
	"./wallet/gradient-fourblock-icon.png": 54766,
	"./wallet/gradient-hata-user.png": 18816,
	"./wallet/gradient-wallet-icon.png": 29892,
	"./wallet/hata-user.svg": 94596,
	"./wallet/history-icon.svg": 4927,
	"./wallet/info-circle.svg": 93726,
	"./wallet/message-ques.png": 64026,
	"./wallet/message-ques.svg": 4252,
	"./wallet/money-receive.svg": 74951,
	"./wallet/money-send.svg": 68759,
	"./wallet/no-transaction.png": 7446,
	"./wallet/receive.svg": 64314,
	"./wallet/receivecryptoAction.svg": 36328,
	"./wallet/rewards-icon.svg": 91709,
	"./wallet/rewards.svg": 55331,
	"./wallet/round_check_icon.svg": 54289,
	"./wallet/scan.svg": 51377,
	"./wallet/search-icon.svg": 71759,
	"./wallet/sell.svg": 42306,
	"./wallet/sellAction.svg": 59594,
	"./wallet/send-arrow.svg": 63957,
	"./wallet/send.svg": 57656,
	"./wallet/sendcryptoAction.svg": 90623,
	"./wallet/spot-trade-icon.svg": 82521,
	"./wallet/trade-arrow.svg": 93431,
	"./wallet/verify-icon.svg": 66527,
	"./wallet/wallet-icon.png": 60791,
	"./wallet/wallet-icon.svg": 16507,
	"./wallet/wifi.svg": 84593,
	"./wallet/withdraw.svg": 81414,
	"./wallet/withdrawAction.svg": 1608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;